import { Button } from '@parsina/framework';
import { Building2 } from 'lucide-react';
import { useClinicSwitch, enterClinicPanel } from '../../hooks/useClinicSwitch';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// The settings-side twin of the sidebar's «رفتن به پنل کلینیک» switch.
//
// The sidebar row is the one a doctor uses daily; this is the one they find
// when they go looking, in the «مطب‌ها» section that already answers "which
// clinics am I in". Both surfaces (web + mobile settings) render THIS, so the
// eligibility rule and the destination stay one fact rather than three.
//
// Renders nothing when there is no clinic to enter — same rule as the sidebar:
// hidden, never disabled.
const ClinicSwitchButton = ({ className }) => {
  const { t } = useTranslation();
  const { canSwitch, targets } = useClinicSwitch();
  if (!canSwitch) return null;
  return (
    <Button
      variant="outline"
      data-testid="settings-switch-to-clinic"
      className={className}
      // Plain navigation, same tab: the clinic panel signs in silently off the
      // shared Keycloak session (same `parsina-web` client, same realm).
      //
      // With exactly one clinic the target is named, so the panel opens THAT one
      // rather than inferring. With several, the bare root is correct: this button
      // makes no choice, and the panel's own switcher is where one is made.
      onClick={() => enterClinicPanel(targets.length === 1 ? targets[0] : undefined)}
    >
      <Building2 size={16} aria-hidden />
      {t('nav.clinicSwitch.open')}
    </Button>
  );
};

export default ClinicSwitchButton;
